module.exports = __webpack_public_path__ + "static/media/Acrilico (37).04331e76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Acrilico/Acrilico (37).jpg
// module id = 305
// module chunks = 0